<template>
  <mask-side-section-container :title="sectionTitle">
    <v-flex style="height: 100%; overflow: auto" class="scroll-fire-fox">
      <div
        v-if="ductEntryTypes.length > 0"
        v-for="ductEntryType in ductEntryTypes"
        :key="ductEntryType.code"
      >
        <v-divider />
        <v-layout
          row
          align-center
          justify-space-around
          class="btn py-2"
          :class="{ selected: ductEntryType === selectedDuctEntryType }"
          @click="toggleDuctEntryOption(ductEntryType)"
        >
          <v-flex xs7>
            <duct-entry-shape
              :shape="ductEntryType.shape"
              :width="ductEntryType.width"
              :height="ductEntryType.height"
            />
          </v-flex>

          <v-flex xs5>
            <v-layout column>
              <v-flex>{{ ductEntryType.libelle }}</v-flex>
              <v-flex>{{ ductEntryType.size }}</v-flex>
              <v-flex>
                <span>
                  {{ ductEntryType.containerWidth }} x
                  {{ ductEntryType.containerHeight }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </mask-side-section-container>
</template>

<script>
import { mapActions } from "vuex";
import { ductEntryTypesMixin } from "@/mixins/forms/masks/ductEntryTypesMixin";
import DuctEntryShape from "./DuctEntryShape";
import MaskSideSectionContainer from "../Masks/MaskSideSectionContainer";

export default {
  name: "DuctEntriesSelector",

  components: { MaskSideSectionContainer, DuctEntryShape },

  mixins: [ductEntryTypesMixin],

  computed: {
    gridUnitSize() {
      return this.$store.getters.getMaskGridUnitSize;
    },

    mode() {
      return this.$store.getters.getMaskDuctEntryMode;
    },

    sectionTitle() {
      if (this.mode === "create") {
        return this.$i18n.t("AddDuctEntry");
      } else if (this.mode === "resize") {
        return this.$i18n.t("ChangeType");
      }
    },

    selectedDuctEntryType() {
      return this.$store.getters.getSelectedDuctEntryType;
    }
  },

  methods: {
    ...mapActions(["setSelectedDuctEntryType"]),

    toggleDuctEntryOption(ductEntryType) {
      let newSelection;
      if (
        this.selectedDuctEntryType === ductEntryType &&
        this.mode === "create"
      ) {
        newSelection = undefined;
      } else {
        newSelection = ductEntryType;
      }
      this.setSelectedDuctEntryType(newSelection);
    }
  },

  destroyed() {
    this.setSelectedDuctEntryType(undefined);
  }
};
</script>

<style scoped>
.btn:hover {
  background-color: rgba(79, 162, 183, 0.1);
}
.btn.selected {
  background-color: rgba(79, 162, 183, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Duct/DuctEntriesSelector.vue